export const COUNTS_DETAILS_API_ENDPOINTS = {
    TOTAL: '/api/employee/get-total-employee-count-details',
    PRESENT: '/api/task/get-attended-employee-count-details',
    PRESENT_ADMIN: '/api/task/get-attended-employee-count-details-admin',
    ABSENT: '/api/attendance/get-absence-employee-count-details',
    UNACCOUNTED: '/api/task/get-unaccounted-employee-count-details',
    TRUEABSENT: '/api/task/get-true-absence-employee-count-details'
};
